import * as React from "react"
import "./facts.css"
import facts from "./../../../images/facts.webp"
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

const Facts = () => {
    return (
        <section className="wrapper bg-light">
            <div className="container py-14 pt-md-16 pb-md-9">
                <figure className="rounded">
                    <img src={facts} alt=""/>
                </figure>
                <div className="row">
                    <div className="col-xl-10 mx-auto">
                        <div
                            className="card image-wrapper bg-orange text-white mt-n5 mt-lg-0 mt-lg-n50p mb-lg-n50p border-radius-lg-top">
                            <div className="card-body p-9 p-xl-10">
                                <div className="row align-items-center counter-wrapper gy-4 text-center">
                                    <div className="col-6 col-lg-3">
                                        <h3 className="counter counter-lg text-white">
                                            <CountUp start={0} duration={2} end={2000}>
                                                {({countUpRef, start}) => (
                                                    <VisibilitySensor onChange={start} delayedCall>
                                                        <span ref={countUpRef}/>
                                                    </VisibilitySensor>
                                                )}
                                            </CountUp>
                                            +
                                        </h3>
                                        <p>
                                            Completed Orders
                                        </p>
                                    </div>
                                    <div className="col-6 col-lg-3">
                                        <h3 className="counter counter-lg text-white">
                                            <CountUp start={0} duration={2} end={30}>
                                                {({countUpRef, start}) => (
                                                    <VisibilitySensor onChange={start} delayedCall>
                                                        <span ref={countUpRef}/>
                                                    </VisibilitySensor>
                                                )}
                                            </CountUp>
                                            +
                                        </h3>
                                        <p>
                                            Countries Delivered
                                        </p>
                                    </div>
                                    <div className="col-6 col-lg-3">
                                        <h3 className="counter counter-lg text-white">
                                            <CountUp start={0} duration={2} end={300}>
                                                {({countUpRef, start}) => (
                                                    <VisibilitySensor onChange={start} delayedCall>
                                                        <span ref={countUpRef}/>
                                                    </VisibilitySensor>
                                                )}
                                            </CountUp>
                                            +
                                        </h3>
                                        <p>
                                            Happy Customers
                                        </p>
                                    </div>
                                    <div className="col-6 col-lg-3">
                                        <h3 className="counter counter-lg text-white">
                                            <CountUp start={0} duration={2} end={100}>
                                                {({countUpRef, start}) => (
                                                    <VisibilitySensor onChange={start} delayedCall>
                                                        <span ref={countUpRef}/>
                                                    </VisibilitySensor>
                                                )}
                                            </CountUp>
                                            +
                                        </h3>
                                        <p>
                                            Expert Employees
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Facts